import { useState, useEffect } from 'react';
import Meta from '../components/Meta';

export default function About() {
  const competencies = [
    {
      title: 'Indkøbsstrategi for el',
      desc: 'Vi udarbejder skræddersyede indkøbsstrategier baseret på din virksomheds behov og risikoprofil.'
    },
    {
      title: 'Finansielle elaftaler',
      desc: 'Vi rådgiver om og forhandler komplekse finansielle elaftaler, herunder fastpris og spot.'
    },
    {
      title: 'Markedsanalyse',
      desc: 'Vi foretager løbende analyser af energimarkedet for at sikre rettidig afdækning og optimalt indkøb.'
    },
    {
      title: 'Uvildig rådgivning',
      desc: 'Vi er 100% uafhængige af energileverandørerne, hvilket sikrer, at vores råd altid tjener din bundlinje.'
    }
  ];

  const certifications = [
    {
      title: 'Over 25 års erfaring',
      issuer: 'Siden 1991',
      desc: 'Vi har beskæftiget os med energi siden 1991, hvilket giver os en unik indsigt og historisk ballast.'
    },
    {
      title: 'Dyb markedsindsigt',
      issuer: 'EnergiMælgere.dk',
      desc: 'Vi foretager analyser af energimarkedet og arbejder med, hvordan vi kan hjælpe virksomheder med at få et indblik i, hvordan energimarkedet fungerer.'
    },
    {
      title: 'En del af KnowHow GROUP',
      issuer: 'KnowHow GROUP',
      desc: 'Vores tilknytning til KnowHow GROUP sikrer finansiel styrke og adgang til de bedste eksperter.'
    }
  ];

  return (
    <>
      <Meta 
        title="Om os" 
        description="Læs mere om EnergiMælgere.dk. Vi har beskæftiget os med energi siden 1991, hvorfor vi har stor indsigt i og erfaring med at arbejde inden for energimarkedet."
      />

      {/* Header Section */}
      <section className="bg-brand-dark text-white py-24 relative overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img 
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1920,quality=85,format=auto/assets/57398cfb-6e5d-4ba8-a3b9-c24b8dc48392/b2b-energy-trading-office.jpg" 
            alt="Moderne B2B energihandel kontor" 
            className="w-full h-full object-cover object-center opacity-40"
          />
          <div className="absolute inset-0 bg-slate-950/40" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 space-y-4">
          <span className="text-xs font-bold uppercase tracking-widest text-white">Hvem er vi</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-tight mb-6">
            Om os
          </h1>
          <p className="text-slate-300 text-base md:text-lg leading-relaxed max-w-2xl">
            Vi har beskæftiget os med energi siden 1991, hvorfor vi har stor indsigt i og erfaring med at arbejde inden for energimarkedet.
          </p>
        </div>
      </section>

      {/* Presentation & History */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-16 items-stretch">
          <div className="lg:col-span-6 space-y-6">
            <span className="text-xs font-bold uppercase tracking-widest text-brand-orange">Vores historie</span>
            <h2 className="text-3xl font-black text-slate-800 tracking-tight leading-tight">
              Bygget på stor indsigt og <span className="text-brand-orange">erfaring</span>
            </h2>
            <p className="text-brand-muted text-sm leading-relaxed">
              EnergiMælgere.dk er udbyder af indkøbs strategi udarbejdet efter din virksomheds behov samt finansielle elaftaler. Vi har viden og kendskab til markedet så vi kan forklare hvordan dette hænger sammen så vi kan forstå det.
            </p>
            <p className="text-brand-muted text-sm leading-relaxed">
              Vores produkter giver dig trykhed og stabilitet omkring dine energiomkostninger også selv om markedet svinger, ikke mindst får du den viden til at gennemskue markedet og gøre dig i stand til at agere i dette markedet samt sortere i alle de som vil sælge EL/energi ”meget” billigere end andre.
            </p>
            <p className="text-brand-muted text-sm leading-relaxed">
              Vi klarer alt det praktiske arbejdet, så du kan læne dig tilbage og se det positive resultat på bundlinjen. Vi står altid til rådighed, hvis du har spørgsmål.
            </p>
            <p className="text-brand-muted text-sm leading-relaxed">
              Vi har beskæftiget os med energi siden 1991, hvorfor vi har stor indsigt i og erfaring med at arbejde inden for energimarkedet. Vi foretager analyser af energimarkedet og arbejder med, hvordan vi kan hjælpe virksomheder med at få et indblik i hvordan energimarkedet er skabt, og ikke mindst hvordan det fungere i den virkelige verden, har man en fastpris fx når man låser sit forbrug og pris ?
            </p>
            <p className="text-brand-muted text-sm leading-relaxed">
              Vores mere end 25 års erfaring samt vores store indsigt i energimarkedet gør os til den oplagte samarbejdspartner til energimarkedet.
            </p>
          </div>
          <div className="lg:col-span-6 flex flex-col gap-6 h-full">
            <div className="relative flex-1 rounded-sm overflow-hidden border border-slate-100 shadow-sm bg-white p-10 flex items-center justify-center min-h-[250px]">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/57398cfb-6e5d-4ba8-a3b9-c24b8dc48392/screenshot-2026-06-24-at-11-04-59.png" 
                alt="Energimarkedets opbygning og infrastruktur" 
                className="max-w-full max-h-[220px] object-contain"
              />
            </div>
            <div className="relative flex-1 rounded-sm overflow-hidden border border-slate-100 shadow-sm bg-white p-10 flex items-center justify-center min-h-[250px]">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/57398cfb-6e5d-4ba8-a3b9-c24b8dc48392/screenshot-2026-06-24-at-11-05-29.png" 
                alt="Elprisudvikling og spotpriser" 
                className="max-w-full max-h-[220px] object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Spar penge på energi Section */}
      <section className="py-24 bg-brand-light border-t border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-7 space-y-8">
              <span className="text-xs font-bold uppercase tracking-widest text-brand-green">Effektivisering</span>
              <h2 className="text-3xl sm:text-4xl font-black text-brand-dark tracking-tight leading-tight">
                Spar penge på energi – <span className="text-brand-green">uden at bruge tid på det selv</span>
              </h2>
              
              <div className="space-y-6 text-brand-muted text-sm leading-relaxed">
                <p className="text-base font-semibold text-brand-dark">
                  Som virksomhed med et betydeligt energiforbrug ved I, at energiomkostninger er en af jeres største driftsudgifter – og at markedet for energi er komplekst, uforudsigeligt og i konstant forandring.
                </p>
                <p>
                  Spørgsmålet er ikke, om I kan spare penge på jeres energi. Spørgsmålet er, om I har ressourcerne og markedsindsigten til at gøre det selv.
                </p>
                <p className="font-bold text-brand-orange text-base">
                  Det er præcis her, vi kommer ind i billedet.
                </p>
                <p className="text-brand-dark font-medium">
                  Vi er energimæglere – og vores job er at sikre, at I altid betaler den rigtige pris for jeres energi. Det gør vi ved at:
                </p>
              </div>

              <ul className="space-y-4">
                {[
                  'Forhandle de bedste aftaler med leverandører på vegne af jer',
                  'Overvåge energimarkedet løbende og reagere når priserne bevæger sig',
                  'Optimere jeres energiprofil, så I køber strøm og gas, når det er billigst',
                  'Rådgive om grønne energiaftaler og CO₂-reduktion',
                  'Håndtere al administration, fakturakontrol og leverandørkontakt'
                ].map((bullet, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <span className="flex-shrink-0 h-6 w-6 rounded-full bg-brand-green/10 flex items-center justify-center text-brand-green text-xs mt-0.5">
                      <i className="fa-solid fa-check" />
                    </span>
                    <span className="text-brand-dark font-semibold text-sm">{bullet}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:col-span-5 bg-white p-8 sm:p-10 rounded-sm border border-slate-100 shadow-sm space-y-8 lg:sticky lg:top-24">
              <div className="space-y-4">
                <div className="text-brand-green text-4xl">
                  <i className="fa-duotone fa-solid fa-chart-line-up" />
                </div>
                <h3 className="text-xl font-black text-brand-dark">
                  Mærkbare resultater for jeres bundlinje
                </h3>
                <p className="text-brand-muted text-xs leading-relaxed">
                  Vores kunder sparer i gennemsnit <strong className="text-brand-green text-sm font-bold">10–25%</strong> på deres energiregning – uden at skulle bruge intern tid eller ekspertise på det.
                </p>
                <p className="text-brand-muted text-xs leading-relaxed">
                  Vi arbejder udelukkende på jeres vegne – ikke på leverandørernes. Det betyder, at I altid kan stole på, at vores anbefalinger er i jeres interesse.
                </p>
              </div>

              <div className="border-t border-slate-100 pt-8 space-y-4">
                <h4 className="text-sm font-bold text-brand-dark">
                  Uforpligtende gennemgang?
                </h4>
                <p className="text-brand-muted text-xs leading-relaxed">
                  Må vi kontakte jer for en uforpligtende gennemgang af jeres nuværende energiaftaler? Vi vurderer hurtigt, om der er et besparelsespotentiale – og hvad det konkret kan betyde for jeres bundlinje.
                </p>
                <div className="pt-2">
                  <a 
                    href="/kontakt" 
                    className="w-full text-center bg-brand-green hover:bg-emerald-700 text-white font-bold tracking-wider text-xs px-6 py-4 rounded-sm uppercase transition-colors duration-200 inline-block"
                  >
                    Få en gratis gennemgang
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Competencies Section */}
      <section className="py-24 bg-brand-light border-t border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto space-y-4 mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-brand-orange">Vores kompetencer</span>
            <h2 className="text-3xl font-black text-slate-800 tracking-tight">
              Hvad vi er <span className="text-brand-orange">specialister</span> i
            </h2>
            <p className="text-brand-muted text-sm leading-relaxed max-w-xl mx-auto">
              Vores brede vifte af kompetencer sikrer, at du altid får en helhedsorienteret og professionel løsning.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {competencies.map((comp, idx) => (
              <div key={idx} className="bg-white p-8 rounded-sm border border-slate-100 shadow-sm space-y-3">
                <div className="h-10 w-10 rounded-sm bg-brand-light flex items-center justify-center text-brand-orange text-lg">
                  <i className="fa-regular fa-circle-check" />
                </div>
                <h3 className="text-base font-bold text-brand-dark">{comp.title}</h3>
                <p className="text-brand-muted text-xs leading-relaxed">{comp.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto space-y-4 mb-16">
            <span className="text-xs font-bold uppercase tracking-widest text-brand-orange">Vores fundament</span>
            <h2 className="text-3xl font-black text-slate-800 tracking-tight">
              Erfaring, indsigt og <span className="text-brand-orange">stærke partnerskaber</span>
            </h2>
            <p className="text-brand-muted text-sm leading-relaxed max-w-xl mx-auto">
              Vi bygger vores rådgivning på over 25 års erfaring i det danske energimarked og et stærkt koncernbagland.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {certifications.map((cert, idx) => (
              <div key={idx} className="bg-brand-light p-8 rounded-sm border border-slate-100 space-y-4 text-center">
                <div className="text-brand-orange text-4xl">
                  <i className="fa-regular fa-award" />
                </div>
                <div className="space-y-2">
                  <h3 className="text-base font-bold text-brand-dark">{cert.title}</h3>
                  <span className="inline-block bg-brand-orange/10 text-brand-orange text-xs font-bold px-3 py-1 rounded-sm uppercase tracking-wider">
                    {cert.issuer}
                  </span>
                </div>
                <p className="text-brand-muted text-xs leading-relaxed">{cert.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
